import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

const StyledFileDropzone = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .dropzone {
    border: 1px dashed
      ${(props) => (props.iserror ? COLOR.error.base : COLOR.darkBlue[64])};
    background: ${COLOR.darkBlue[4]};
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-size: 16px;
    text-align: center;
    color: ${COLOR.outlined[80]};
    width: ${({ width }) => (width ? `${width}` : '180px')};
  }

  .note-content {
    padding: 12px 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .pointer {
    cursor: pointer;
  }

  .file-input {
    display: none;
  }

  .preview-image {
    border-radius: 12px !important;
    width: 100% !important;
    height: 100% !important;
    object-fit: cover !important;
    max-height: 150px;
  }

  .error {
    margin-top: 4px;
  }

  .action {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .action-buttons {
      display: flex;
      gap: 16px;
    }
  }

  .button-upload {
    display: flex;
    gap: 6px;
    align-items: center;
    justify-content: center;
    padding: 6px 16px;
    width: 160px;
    margin-top: 16px;
  }

  .mt-24 {
    margin-top: 24px;
  }
`;

const StyledImagePreview = styled(Box)`
  display: flex;
  gap: 20px;
  position: relative;

  .preview-image {
    border-radius: 6px;
    max-width: 100%;
    cursor: pointer;
  }

  .delete-image {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: ${COLOR.charcoal[100]};
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.16);
    padding: 4px;
    border-radius: 100%;
    top: -10px;
    right: -10px;
    cursor: pointer;
  }
`;

export { StyledFileDropzone, StyledImagePreview };
